import { get } from '../utils/axios'

export const getWelfareEjipsAPI = async (body) => {
  return await get('welfares/ejips', body)
}

export const getEjipFundNameAPI = async () => {
  return await get('getEjipFundName')
}

export const getEjipFundRoundNameAPI = async (body) => {
  return await get('getEjipFundRoundName', body)
}
